import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { If, Then, Else} from 'react-if';
import { useMutation } from '@apollo/client';


import {  useHistory, NavLink } from 'react-router-dom';
import 'moment/locale/es';

const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

//Components
import AcreditacionProfile, {LIST_ABONOS_PROFILE} from '../models/AcreditacionProfile';

import Loading from '../components/Loading';
import { textAreaStyle } from '../styles/includes/forms'

// Assets
import btnMisDatos from '../assets/menu/01_mis-datos.jpg';
import btnMisAsientos from '../assets/menu/02_mis-asientos.jpg';
import btnNotificaciones from '../assets/menu/03_notificaciones.jpg';
import btnBeneficios from '../assets/menu/04_beneficios.jpg';
import btnDescuentos from '../assets/menu/05_descuentos.jpg';
import btnPuntos from '../assets/menu/06_mis-puntos-atleti.jpg';
import btnSeguro from '../assets/menu/07_seguro-atleti.jpg';
import btnCalendario from '../assets/menu/08_calendario.jpg';
import btnGaleria from '../assets/menu/09-galeria-de-fotos.jpg';

import btnAtencion from '../assets/menu/011_atencion-personal.jpg';
import btnPreguntas from '../assets/menu/012-preguntas.jpg';
import btnProtocolo from '../assets/menu/016_protocolo-estadio.jpg';
import btnContacto from '../assets/menu/014-contacto.jpg';
import btnPromoDia from '../assets/menu/015-promo-partido.jpg';



const StyledPage = styled.main`
  padding: 2rem;
  .event-wrapper {
    & > * {
      &:not(:last-child) {
        border-bottom: 1px solid var(--color-gray-light);
      }
    }
  }
  .status-info-wrapper {
    margin-top: 2rem;
  }
`


const Contenido=styled.div`
  .txt-subtitle{
      color:var(--color-azul);
      font-size:20px; 
      font-weight:bold;
  }
  .txt-paragraph{
      color:#a6a6a6; font-size:15px;
      line-height: 30px;
  }
  .btn-cuenta{
      width:100%; background-color:#cc3723; color:#ffffff; border:none; border-bottom:10px solid var(--color-azul); text-align:left;
      height:65px;
      span{
          font-size: 20px;
      }
  }

  .disabled{
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: all !important;
    filter: grayscale(90%);
  }
  
`;


const StyledForm = styled.form`
  h1 {
    margin-bottom: 2.5rem;
  }
  h4 {
    font-size:15px;
    color: #000;
    margin: 1.3rem 0;
    strong{
      color:#f10000;
    }
  }
  textarea {
    ${textAreaStyle}
    width: 100%;
    height: 80px;
    padding: 12px;
  }
  .page-footer {
    text-align: center;
    margin-top: 2rem
  }

  
  .sample-photo {
    max-width: 120px;
    margin: auto;
    img {
      box-shadow: var(--base-box-shadow);
      width: 100%;
    }
  }
`

export default  () => {
    let UserInfo=AcreditacionProfile.getProfile();

    const [ getListAbonosProfile,{ data } ] = useMutation(LIST_ABONOS_PROFILE);
    const [submitError,setSubmitError] = useState<null|string>(null);
    const [loading,setLoading] = useState(true);
    const [content,setContent] = useState(null);


    useEffect(() => {
        (async () => {
            try{
                setLoading(true);

                const responseQuery=await getListAbonosProfile({
                    variables:{
                        profile_uuid:UserInfo.uuid
                    }
                });

                console.log('Query:',responseQuery);

                let response= await fetch('https://www.atleticodesanluis.mx/webservices/get_content/usuario-sin-abono');
                let responseJson=await response.json();

                if(responseQuery?.data?.listAbonos?.total==0)
                    setContent(responseJson?.conten);
            
            }catch(e){
                console.error(e);
                setSubmitError(e);
                window.scrollTo(0,0);
            }finally{
                setLoading(false);
            }
        })();
    },[]);

    if(loading)
        return <Loading />

    return (
        <StyledPage>
            <If condition={content===null}>
                <Then>
                    <Contenido>
                        <div className="section bg-white sep-50">
                            <div className="container ">
                                <div className="text-left mb-4 txt-subtitle">
                            ¡Hola {UserInfo.name?.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase())}!
                                </div>
                                <div className="text-left txt-paragraph">
                                    <p>¡Bienvenido a tu portal!</p>
                                    <p>{UserInfo.name?.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase())} con el motivo de asegurar que conozcas todos tus eventos y beneficios, 
                            construimos esta plataforma dónde puedes revisar tus asientos, próximos partidos, descuentos con nuestros socios comerciales, ¡y mucho más!</p>
                            
                                    <p>Mejora tu experiencia revisando información del estadio, preguntas frecuentes, y como siempre, tu como abonado tienes contacto 
                            directo con el club para cualquier duda y/o sugerencia. ¡Nos vemos muy pronto!</p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-wrap col-sm-12 col-md-12"> 
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/micuenta" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnMisDatos} />
                                </NavLink> 
                            </div> 
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/abonos" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnMisAsientos} />
                                </NavLink> 
                            </div>                                           
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/contenidos/beneficios-abonos" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnBeneficios} />
                                </NavLink> 
                            </div>          
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/descuentos" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnDescuentos} />
                                </NavLink> 
                            </div> 
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/dayPromo" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnPromoDia} />
                                </NavLink> 
                            </div>                                 
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/puntos" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnPuntos} />
                                </NavLink> 
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/contenidos/seguro-atleti" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnSeguro} />
                                </NavLink> 
                            </div> 
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/eventos" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnCalendario} />
                                </NavLink> 
                            </div> 
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <a  href="https://atleticodesanluis.mx/fotogalerias_abonados" target='_blank' className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnGaleria}  className=''/>
                                </a> 
                            </div> 
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/antecion-personal" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnAtencion} />
                                </NavLink> 
                            </div>    
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/contenidos/faq" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnPreguntas} />
                                </NavLink> 
                            </div>    
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/rumbo-al-lastras" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnProtocolo} />
                                </NavLink> 
                            </div>    
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/contenidos/contacto-abonados" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnContacto} />
                                </NavLink> 
                            </div>          
                            <div className='col-12 col-sm-6 col-md-4 my-4'>
                                <NavLink  to="/notificaciones" className="py-2 p-x-2 d-flex flex-wrap  justify-content-around align-items-center">    
                                    <img  src={btnNotificaciones}/>
                                </NavLink> 
                            </div>                                                                                                                                                                                                                                                                                                                                                                             
                        </div>
                    </Contenido>
                </Then>
                <Else>
                    <StyledForm>
                        <div dangerouslySetInnerHTML={{ __html: content}} />
                    </StyledForm>
                </Else>
            </If>
        </StyledPage>
    )
}

